import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import DeadLetterTopicsActionSearchListViewModel from "viewModels/administration/deadLetterTopics/actionSearch/deadLetterTopicsActionSearchListViewModel";
import type DeadLetterTopicMessageAction from "entities/deadLetterTopicMessageActionResponse";
import { deadLetterTopicActionTypeToVariant } from "entities/deadLetterTopicActionType";
import { formatDateTime, formatNumber, translateEnum } from "utils/localizations";
import ListView from "views/common/list";
import DeadLetterTopicsActionSearchFilters from "./deadLetterTopicsActionSearchFilters";

const DeadLetterTopicsSearchListView: ViewComponent<DeadLetterTopicsActionSearchListViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<DeadLetterTopicMessageAction>[] = [
    {
      property: "createdAt",
      title: vm.translateAttribute("createdAt"),
      valueFormatter: props => formatDateTime(props.item.createdAt),
      cellClassName: "text-left",
      headerClassName: "text-left",
    },
    {
      property: "type",
      title: vm.translateAttribute("type"),
      valueFormatter: props => {
        const variant = deadLetterTopicActionTypeToVariant(props.item.type);
        return <strong className={`text-${variant}`}>{translateEnum("deadLetterTopicActionType", props.item.type)}</strong>;
      },
    },
    {
      property: "createdBy",
      title: vm.translateAttribute("createdBy"),
    },
    {
      property: "messageCount",
      title: vm.translateAttribute("messageCount"),
      valueFormatter: props => formatNumber(props.item.messageCount),
      cellClassName: "text-left",
      headerClassName: "text-left",
    },
  ];

  return (
    <>
      <DeadLetterTopicsActionSearchFilters vm={vm} />
      <ListView vm={vm} columns={columns} hideButtons={true} hideTitle={true} />
    </>
  );
});

registerView(DeadLetterTopicsSearchListView, DeadLetterTopicsActionSearchListViewModel);
